module.exports = __webpack_public_path__ + "img/tiktok-logo-gray.6429c16b.svg";